import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import Buscador from "../../Buscador/Buscador"
import Cardsimple from "../../cards/Cardsimple"
import Pagination from "../../pagination/Pagination"
import getCatalogoSap from "../../services/catalogosap/getCatalogoSap"
import TableSap from "./TableSap"
import Topnavbar from "../../sections/Topnavbar"
import { Helmet, HelmetProvider } from "react-helmet-async"
import Leftnavbar from "../../sections/Leftnavbar"
import LoaderEquipment from "../../loaders/LoaderEquipment"
import Footerbar from "../../sections/Footerbar"


const CatalogoSap = () => {
    let { search } = useLocation()
    let query = new URLSearchParams(search)
    let busqueda = query.get("bus") || ""
    let paginaURL = query.get("pag") || 1
    let filtro = query.get("fil") || ""
    let paginaAPI = 1
    let totalResultados = 0
    let totalPaginas = 1
    let tamanioPagina = 1

    const [catalogoSap, setCatalogoSap] = useState()

    useEffect(() => {
        getCatalogoSap(busqueda, paginaURL, filtro)
            .then((data) => {
                if (data.error === 401) {
                    setCatalogoSap(401)
                }
                else {
                    setCatalogoSap(data)
                }
                window.scrollTo(0, 0)

            })
    }, [busqueda, paginaURL, filtro])

    if (catalogoSap) {
        totalResultados = catalogoSap.totalResultados
        totalPaginas = catalogoSap.totalPaginas
        tamanioPagina = catalogoSap.tamanioPagina
        paginaAPI = catalogoSap.paginaActual
    }

    const Titulo = () => { return (<span className="font-weight-light">{" : \"" + busqueda.charAt(0).toUpperCase() + busqueda.slice(1)}"</span>) }
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>CATALOGO SAP</title>
                </Helmet>
            </HelmetProvider>
            <Leftnavbar />
            <Topnavbar />
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-10">
                                <h1 className="m-0">{<>Catálogo <span style={{ color: "#444", fontWeight: "bold" }}>SAP</span> {(busqueda) && <Titulo />}</>}</h1>
                            </div>
                            <div className="col-lg-2">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Catálogo SAP</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 text-sm">
                                <Cardsimple
                                    condensed={true}
                                    header={
                                        <div className="row">
                                            <div className="col-md-8">
                                                <Buscador
                                                    dataBusqueda={busqueda}
                                                    dataPagina="catalogosap"
                                                    filtroValue={filtro}
                                                    filtros={[
                                                        { texto: "Todos", value: "" },
                                                        { texto: "Repuestos", value: "rep" },
                                                        { texto: "Ferretería", value: "fer" },
                                                        { texto: "Material Médico", value: "med" }
                                                    ]}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Pagination
                                                    busqueda={busqueda}
                                                    page="catalogosap"
                                                    pagActual={paginaURL}
                                                    pagAPI={paginaAPI}
                                                    totalPaginas={totalPaginas}
                                                    filtroValue={filtro}
                                                />
                                            </div>
                                        </div>
                                    }
                                >
                                </Cardsimple>

                                {
                                    (!catalogoSap) ? <LoaderEquipment /> : (
                                        <Cardsimple
                                            condensed={true}
                                            footer={
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <div className="p-1">Resultados de la búsqueda :  {totalResultados}</div>
                                                    </div>
                                                    <div className="col-md-8">
                                                        <Pagination
                                                            busqueda={busqueda}
                                                            page="catalogosap"
                                                            pagActual={paginaURL}
                                                            pagAPI={paginaAPI}
                                                            totalPaginas={totalPaginas}
                                                            filtroValue={filtro}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                        >
                                            <TableSap datos={catalogoSap} />
                                        </Cardsimple>

                                    )
                                }

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footerbar />
        </>
    )
}
export default CatalogoSap